import { TableCell, TableHead, TableRow } from "@mui/material";
import { memo } from "react";

import { ROLES_TABLE_DATA_COLUMNS } from "./constants";

export const RolesTableHead = memo(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell key="entityName">Entity Name</TableCell>
        {ROLES_TABLE_DATA_COLUMNS.map((column) => (
          <TableCell className="capitalize" key={column}>
            {column}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
});

RolesTableHead.displayName = "RolesTableHead";
